import React from 'react';
import { Link } from 'react-router-dom';

export default function HeroSection({ heading, subheading }) {
  return (
    <div style={styles.hero}>
      <div style={styles.circle1} />
      <div style={styles.circle2} />

      <div style={styles.content}>
        <div style={styles.badge}>🌿 Willkommen in der Natur</div>
        <h1 style={styles.heading}>{heading}</h1>
        <p style={styles.subheading}>{subheading}</p>
        <div style={styles.actions}>
          <Link to="/buchung" style={styles.ctaPrimary}>Jetzt anfragen</Link>
          <Link to="/galerie" style={styles.ctaSecondary}>Galerie ansehen</Link>
        </div>
      </div>

      <div style={styles.waveWrapper}>
        <svg viewBox="0 0 1440 80" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" style={{ display: 'block', width: '100%', height: '80px' }}>
          <path d="M0,40 C360,80 1080,0 1440,40 L1440,80 L0,80 Z" fill="#ffffff"/>
        </svg>
      </div>
    </div>
  );
}

const F = "'Inter', system-ui, sans-serif";

const styles = {
  hero: {
    position: 'relative',
    overflow: 'hidden',
    background: 'linear-gradient(175deg, #f0fdf4 0%, #ffffff 60%)',
    minHeight: '520px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderBottom: '1px solid #e5e7eb',
  },
  circle1: {
    position: 'absolute',
    top: '-80px',
    right: '-120px',
    width: '480px',
    height: '480px',
    borderRadius: '50%',
    background: 'rgba(30,132,73,0.04)',
    pointerEvents: 'none',
  },
  circle2: {
    position: 'absolute',
    bottom: '-100px',
    left: '-60px',
    width: '380px',
    height: '380px',
    borderRadius: '50%',
    background: 'rgba(30,132,73,0.03)',
    pointerEvents: 'none',
  },
  content: {
    position: 'relative',
    zIndex: 2,
    textAlign: 'center',
    padding: '5rem 2rem 5.5rem',
    maxWidth: '720px',
  },
  badge: {
    display: 'inline-block',
    backgroundColor: '#dcfce7',
    color: '#15803d',
    padding: '0.3rem 0.9rem',
    borderRadius: '20px',
    fontSize: '0.78rem',
    fontFamily: F,
    fontWeight: '600',
    letterSpacing: '0.8px',
    marginBottom: '1.5rem',
  },
  heading: {
    color: '#111827',
    fontSize: 'clamp(2.2rem, 5.5vw, 3.5rem)',
    fontFamily: F,
    fontWeight: '700',
    lineHeight: '1.15',
    marginBottom: '1.1rem',
    letterSpacing: '-0.8px',
  },
  subheading: {
    color: '#6b7280',
    fontSize: 'clamp(1rem, 2.2vw, 1.15rem)',
    fontFamily: F,
    fontWeight: '400',
    marginBottom: '2.5rem',
    lineHeight: '1.75',
  },
  actions: {
    display: 'flex',
    gap: '0.85rem',
    justifyContent: 'center',
    flexWrap: 'wrap',
  },
  ctaPrimary: {
    display: 'inline-block',
    backgroundColor: '#1e8449',
    color: 'white',
    textDecoration: 'none',
    padding: '0.9rem 2.2rem',
    borderRadius: '8px',
    fontWeight: '600',
    fontSize: '0.95rem',
    fontFamily: F,
    boxShadow: '0 2px 8px rgba(30,132,73,0.3)',
  },
  ctaSecondary: {
    display: 'inline-block',
    backgroundColor: 'white',
    color: '#374151',
    textDecoration: 'none',
    padding: '0.9rem 2.2rem',
    borderRadius: '8px',
    fontWeight: '500',
    fontSize: '0.95rem',
    fontFamily: F,
    border: '1.5px solid #e5e7eb',
    boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
  },
  waveWrapper: { display: 'none' },
};
